export default [
  {
    path: '/advertisement',
    name: 'advertisement',
    component: () => import('@/views/menu/advertisement/advertisement.vue'),
    meta: {
      pageTitle: 'مدیریت آگهی ها',
      action: 'show',
      resource: 'AdvertisementManager',
    },
  },
]
